var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-tab',{staticClass:"user-notifications-tab-updates",attrs:{"label":_vm.$t('header.notificationsTab.modalTabTitle'),"id":"notification-dialog-updates"}},[(_vm.hasUpdates)?_c('user-notifications-list',_vm._l((_vm.updates),function(ref,index){
var title = ref.title;
var description = ref.description;
var date = ref.date;
return _c('user-notifications-list-item',{key:index,attrs:{"disabled":"","icon":"exclamation","title":title + ':',"description":description,"date":date}})}),1):_c('user-notifications-empty-state')],1)}
var staticRenderFns = []

export { render, staticRenderFns }